import React from "react";
import { ReactComponent as Star } from "../../../assets/star-slide.svg";
import { ReactComponent as Like } from "../../../assets/Like.svg";
import { ReactComponent as RibbonStar } from "../../../assets/Medal Ribbons Star.svg";
import { ReactComponent as BankNote } from "../../../assets/Banknote 2.svg";
const Results = () => {
  return (
    <div style={{ overflow: "hidden", background: "#e6f6ff" }}>
      <div className="ellipse">
        <Star className="ellipse-inner" />
        <div className="result-text-wrapper">
          <h1 className="header" style={{ textAlign: "center" }}>
            Our results speak for themselves
          </h1>
          <p
            className="sub-header"
            style={{ width: "50%", margin: "30px auto" }}
          >
            Our proven track record shows our dedication to helping clients
            secure the compensation they deserve. With a 94% success rate and
            over $1.2M recovered in 2024, we deliver results you can trust.
          </p>
        </div>
      </div>

      <div className="world-map-wrapper">
        <div className="card-container">
          <div className="card-wrapper">
            <Like />
            <span className="card-couter">1697</span>
            <span className="card-text">Claims filed in 2024</span>
          </div>

          <div className="card-wrapper">
            <BankNote />
            <span className="card-couter">$1.2M</span>
            <span className="card-text">Compensation recovered</span>
          </div>

          <div className="card-wrapper">
            <RibbonStar />
            <span className="card-couter">94%</span>
            <span className="card-text">Success rate</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Results;
